import { HYDRATING } from '../utils/hydrating';

let firstRouteMounted = false;

/**
 * True for the whole first paint of a page: always on the server (build) and, in the browser, while a
 * prerendered document is being hydrated (until the first routed page has mounted).
 * Used to keep animations from starting at opacity 0 in the HTML and in the hydration render.
 */
export const isInitialPaint = (): boolean => typeof window === 'undefined' || (HYDRATING && !firstRouteMounted);

export const markFirstRouteMounted = (): void => {
  firstRouteMounted = true;
};
